import React from "react";

const UploadBox = ({ label = "Profile Picture", subtext = "Max 20mb pdf", padding = "p-4"}) => {
    return (
        <div
            className="border border-dashed rounded d-inline-flex flex-column justify-content-center align-items-center p-4 text-center"
            style={{cursor: "pointer" }}
        >
            <div className={`d-flex flex-column align-items-center ${padding} gap-1`}>
                <i className="bi bi-upload fs-4 text-muted  mb-2"></i>
                <p className="fw-semibol mb-0 small-text">{label}</p>
                <small className="text-muted smaller-text">{subtext}</small>
                <input type="file" className="d-none"/>
            </div>
        </div>
    );
};

export default UploadBox;